import { render, staticRenderFns } from "./Continents.vue?vue&type=template&id=dc09dd7c&scoped=true"
import script from "./Continents.vue?vue&type=script&lang=js"
export * from "./Continents.vue?vue&type=script&lang=js"
import style0 from "./Continents.vue?vue&type=style&index=0&id=dc09dd7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc09dd7c",
  null
  
)

export default component.exports